import { useUserSession } from "@addeus/vue3-stores/stores/userSession";
import { createGlobalState } from "@vueuse/core";
import { useProfile } from "./profileStore";

// La liste des événements
export enum SKALIN_EVENTS {
    ABORT_COMPLEMENT_INFORMATION_WITH_SAM = "Abort complement information with Sam",
    ABORT_PLANNING = "Abort planning creation",
    ABORT_CREATE_POST = "Abort create post",
    ACTIONS_NAVIGATION = "Navigate to Publications",
    ADD_ANSWER_ERROR = "Add answer has error",
    ADD_ANSWER_START = "Add answer was started",
    ADD_ANSWER_SUCCESS = "Add answer has success",
    ADD_MEDIA = "Add media",
    ADD_MEDIA_SUCCESS = "Add media success",
    ANALYSIS_NAVIGATION = "Navigate to Analysis",
    AUDIT_NAVIGATION = "Navigate to Audit",
    CANCEL_ANSWER_SUCCESS = "Cancel editing answer success",
    CANCEL_PLANNING = "Cancel planning creation",
    CLICK_PUBLICATION_TAB = "Click publication tab",
    CLICK_REVIEW_FILTER = "Click review filter",
    COMPLEMENT_INFORMATION_WITH_SAM = "Complement information with Sam",
    COMPLETE_WITH_SAM = "Complete with Sam",
    CONNECT_SOCIAL_INSTAGRAM = "Connected social profile Instagram successfully",
    CONNECT_SOCIAL_FACEBOOK = "Connected social profile Facebook successfully",
    CONNECT_SOCIAL_GOOGLE = "Connected social profile Google successfully",
    CONNECT_SOCIAL_LINKEDIN = "Connected social profile LinkedIn successfully",
    CHOOSE_SOCIAL_PROFILE_FACEBOOK = "Choose social profile Facebook",
    CHOOSE_SOCIAL_PROFILE_INSTAGRAM = "Choose social profile Instagram",
    CHOOSE_SOCIAL_PROFILE_LINKEDIN = "Choose social profile LinkedIn",
    CHOOSE_SOCIAL_PROFILE_GOOGLE = "Choose social profile Google",
    CREATE_PLANNING = "Create planning",
    CREATE_POST = "Create post",
    DASHBOARD_NAVIGATION = "Navigate to Dashboard",
    DELETE_ANSWER_SUCCESS = "Delete answer success",
    DELETE_POST = "Delete post",
    DELETE_POST_CANCEL = "Delete post cancel",
    DELETE_POST_CONFIRM = "Delete post confirm",
    DELETE_POST_SUCCESS = "Delete post success",
    DOWNLOAD_AUDIT = "Download audit",
    EDIT_POST_SUCCESS = "Edit post success",
    EXPORT_AUDIT_ERROR = "Export audit error",
    EXPORT_AUDIT_SUCCESS = "Export audit success",
    FINISHED_PLANNING_GENERATION = "Finished planning generation",
    GENERATE_AUDIT = "Generate audit",
    GENERATE_AUDIT_ERROR = "Generate audit error",
    GENERATE_AUDIT_ERROR_NOT_ENOUGH_DATA = "Generate audit error: not enough data",
    GENERATE_AUDIT_SUCCESS = "Generate audit success",
    INFORMATION_NAVIGATION = "Navigate to Information",
    INIT_SAM_AUDIT = "Initialize Sam in audit",
    MEDIA_NAVIGATION = "Navigate to Media",
    MESSAGE_NAVIGATION = "Navigate to Message",
    MESSAGE_SAM_AUDIT = "Message Sam in audit",
    MODIFY_PLANNING = "Modify planning",
    MODIFY_POST = "Modify post",
    PASSED_EIGHTH_STEP_IN_PLANNING_GENERATION = "Passed eighth step in planning generation",
    PASSED_EIGHTH_STEP_MODIFY_CHOSEN_PUBLICATION_IN_PLANNING_GENERATION = "Passed eighth step: modified chosen publication in planning generation",
    PASSED_EIGHTH_STEP_SKIP_MODIFY_CHOSEN_PUBLICATION_IN_PLANNING_GENERATION = "Passed eighth step: skipped modifying chosen publication in planning generation",
    PASSED_EIGHTH_STEP_VALIDATE_CHOSEN_PUBLICATION_IN_PLANNING_GENERATION = "Passed eighth step: validated chosen publication in planning generation",
    PASSED_FIFTH_STEP_IN_PLANNING_GENERATION = "Passed fifth step in planning generation",
    PASSED_FIFTH_STEP_WITH_PREFERENCES_IN_PLANNING_GENERATION = "Passed fifth step with preferences in planning generation",
    PASSED_FIFTH_STEP_WITHOUT_PREFERENCES_IN_PLANNING_GENERATION = "Passed fifth step without preferences in planning generation",
    PASSED_FIRST_STEP_IN_PLANNING_GENERATION = "Passed first step in planning generation",
    PASSED_FOURTH_STEP_IN_PLANNING_GENERATION = "Passed fourth step in planning generation",
    PASSED_SECOND_STEP_IN_PLANNING_GENERATION = "Passed second step in planning generation",
    PASSED_SEVENTH_STEP_IN_PLANNING_GENERATION = "Passed seventh step in planning generation",
    PASSED_SIXTH_STEP_IN_PLANNING_GENERATION = "Passed sixth step in planning generation",
    PASSED_THIRD_STEP_IN_PLANNING_GENERATION = "Passed third step in planning generation",
    PLANNING_NAVIGATION = "Navigate to Planning",
    PLANNING_STEP = "Planning step",
    PUBLICATION_PROGRAMMED = "Post programmed",
    PUBLISH_ANSWER_ERROR = "Publish answer error",
    PUBLISH_ANSWER_START = "Publish answer start",
    PUBLISH_ANSWER_SUCCESS = "Publish answer success",
    PUBLISH_POST = "Publish post",
    QUIT_PLANNING = "Quit planning",
    REFORMULATE_GENERAL_INFO = "Reformulate general info",
    REFORMULATE_PUBLICATION = "Reformulate publication",
    REFORMULATE_SOCIAL = "Reformulate social",
    RESEND_LASTMESSAGE_SAM_AUDIT_ERROR = "Resend last message to Sam in audit error",
    RESEND_LASTMESSAGE_SAM_AUDIT_SUCCESS = "Resend last message to Sam in audit success",
    RESPOND_TO_REVIEW = "Respond to review",
    REVIEW_NAVIGATION = "Navigate to Reviews",
    SAVE_CONTACT_INFORMATION = "Save contact information",
    SAVE_DRAFT_PLANNING = "Save draft planning",
    SAVE_DRAFT_POST = "Save draft post",
    SAVE_GENERAL_INFORMATION = "Save general information",
    SAVE_GENERATED_INFORMATION_WITH_SAM = "Save generated information with Sam",
    SAVE_STRATEGY_INFORMATION = "Save strategy information",
    SAVE_SOCIAL_INFORMATION = "Save social information",
    SEND_MESSAGE_SAM_AUDIT_ERROR = "Send message to Sam in audit error",
    SEND_MESSAGE_SAM_AUDIT_SUCCESS = "Send message to Sam in audit success",
    SETTINGS_NAVIGATION = "Navigate to Settings",
    SIDEBAR_NAVIGATION = "Sidebar navigation",
    STATISTICS_NAVIGATION = "Navigate to Statistics",
    TRY_CONNECT_SOCIAL_NETWORK = "Try connecting social network",
    TRY_CONNECT_SOCIAL_PROFILE_FACEBOOK = "Try connecting social profile Facebook",
    TRY_CONNECT_SOCIAL_PROFILE_INSTAGRAM = "Try connecting social profile Instagram",
    TRY_CONNECT_SOCIAL_PROFILE_LINKEDIN = "Try connecting social profile LinkedIn",
    TRY_CONNECT_SOCIAL_PROFILE_GOOGLE = "Try connecting social profile Google",
    TRY_DELETE_POST = "Try deleting post",
    TRY_EDIT_POST = "Try editing post",
    TRY_EDIT_ANSWER = "Try editing answer",
    TRY_EXPORT_AUDIT = "Try exporting audit",
    TRY_GENERATE_AUDIT = "Try generating audit",
    TRY_MODIFY_PUBLICATION_IN_EIGHTH_STEP_IN_PLANNING_GENERATION = "Try modifying publication in eighth step of planning generation",
    TRY_RESEND_LASTMESSAGE_SAM_AUDIT = "Try resending last message to Sam in audit",
    TRY_SEND_MESSAGE_SAM_AUDIT = "Try sending message to Sam in audit",
    UPDATE_INFO = "Update information",
    UPDATE_PASSWORD = "Update password",
    UPDATE_PASSWORD_ERROR = "Update password error",
    UPDATE_PASSWORD_SUCCESS = "Update password success",
    USE_INSPIRATION_AS_MEDIA = "Use inspiration as media",
    USE_INSPIRATION_IMAGE = "Use inspiration image",
    USER_RETURNED = "User returned after inactivity",
    VALIDATE_PLANNING = "Validate planning",
}

// Instanciate Skalin script and import ska global variable
(function (w, d, l, t) {
    w[t] =
        w[t] ||
        function (...args) {
            const p = [];
            Array.prototype.push.apply(p, args);
            return (w[t].p = w[t].p || []).push(p);
        };
    const g = d.createElement("script");
    g.type = "text/javascript";
    g.defer = true;
    g.async = true;
    g.src = l;
    const s = d.getElementsByTagName("script")[0];
    s.parentNode?.insertBefore(g, s);
})(window, document, "https://assets.skalin.io/scripts/skalin.min.js", "ska");

declare function ska(callback: (skalin: any) => void): void;

/**
 * Send event to skalin
 * Usage:
 * const sendEvent = useSkalin();
 * sendEvent(skalinEvents.publishPost);
 */
export const useSkalin = createGlobalState(() => {
    const userSession = useUserSession();
    const profile = useProfile();
    ska(function (skalin) {
        skalin.clientId("5c98a2bf361a7bd2");
    });

    return function (eventName: string, additionalData?: string): void {
        ska(function (skalin) {
            if (userSession.user.value && profile.currentProfile.value) {
                const currentUser = userSession.user.value;
                skalin.identity({ email: currentUser.email || currentUser.uid });
                skalin.customerId(profile.currentProfile.value.$getID());
                skalin.feature({
                    name:
                        eventName +
                        (typeof additionalData === "string"
                            ? `_${additionalData.toUpperCase()}`
                            : ""),
                });
                // eslint-disable-next-line no-console
                console.debug(
                    "%c Event Skalin",
                    "background:rgb(97, 97, 97); color: white; padding: 2px 5px; border-radius: 3px;",
                    {
                        event: eventName,
                        customerId: profile.currentProfile.value.$getID(),
                        email: currentUser.email || currentUser.uid,
                        data: additionalData,
                    },
                );
            }
        });
    };
});
